import { render, staticRenderFns } from "./Form213.vue?vue&type=template&id=69237228&scoped=true&"
import script from "./Form213.vue?vue&type=script&lang=js&"
export * from "./Form213.vue?vue&type=script&lang=js&"
import style0 from "./Form213.vue?vue&type=style&index=0&id=69237228&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69237228",
  null
  
)

export default component.exports